export default __webpack_public_path__ + "static/media/Fixel_Logo2019vector1.6896a99d.svg";